import "./DropdownContent.css"

const DropdownContent = ({ children, open, toggle, closeOnClick = true }) => {
    const handleClick = (event) => {
        if (closeOnClick) {
            toggle();
        } else {
            // Evita que el clic interno cierre el dropdown en modo multi-selección.
            event.stopPropagation();
        }
    };

    return (
        <div onClick={handleClick} className={`dropdown-content ${open ? "content-open" : null}`}>
            {children}
        </div>
    )
}

export default DropdownContent